import { ListingFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

const DEFAULT_LOCALE = 'en';

export const getJsonLdApartmentComplex = (listing, seo, locale) => {
  const contents = listing.contents[locale] || listing.contents[DEFAULT_LOCALE];
  const firstPhoto = listing.photos.photoList[0];
  const image = firstPhoto
    ? ListingFormatter.buildPhotoUrl(firstPhoto.id, firstPhoto.verified)
    : '';
  return {
    '@context': 'https://schema.org',
    '@type': 'ApartmentComplex',
    name:
      contents.title ||
      contents.adTitle ||
      contents.seoMetaTitle ||
      'Spotahome',
    image,
    address: {
      '@type': 'PostalAddress',
      addressCountry: listing.countryCode,
      addressLocality: listing.cityId,
      postalCode: listing.postalCode
    },
    url: seo.canonical,
    '@mainEntityOfPage': {
      '@type': 'WebPage',
      '@id': seo.canonical
    }
  };
};

export default {
  getJsonLdApartmentComplex
};
